import React, { useState } from "react";
import Modal from "react-modal";
import axios from "axios";
import { toast } from "react-toastify";

import { useLanguage } from "../../context/languageContext";
import Button from "../../components/button";

const API = process.env.REACT_APP_API_ROOT;

/** Add or edit an employee. `employee` null => add. */
const EmployeePopup = ({ employee, handleCloseModal, onSuccess }) => {
    const { adminInfo } = useLanguage();
    const isCreate = !employee;

    const [name, setName] = useState(employee?.name || "");
    const [designation, setDesignation] = useState(employee?.designation || "");
    const [email, setEmail] = useState(employee?.email || "");
    const [error, setError] = useState("");
    const [isSubmit, setIsSubmit] = useState(false);

    const handleSubmit = async () => {
        if (!name.trim()) {
            setError("Please enter a name.");
            return;
        }
        try {
            setIsSubmit(true);
            const headers = { Authorization: `Bearer ${adminInfo.token}` };
            const payload = { name: name.trim(), designation: designation.trim(), email: email.trim() };
            const url = isCreate
                ? `${API}/api/admin/employees/add`
                : `${API}/api/admin/employees/update/${employee.employeeId}`;
            const { data: response } = await axios[isCreate ? "post" : "put"](url, payload, { headers });
            if (response.status) {
                toast.success(isCreate ? "Employee added." : "Employee updated.");
                onSuccess();
                handleCloseModal();
            } else {
                toast.error(response.message || "Could not save this employee.");
            }
        } catch (err) {
            console.error("handleSubmit catch error::", err);
            toast.error(err.response?.data?.message || err.response?.data?.error || "Could not save this employee.");
        } finally {
            setIsSubmit(false);
        }
    };

    return (
        <Modal isOpen onRequestClose={handleCloseModal} className="modal_body_sm" overlayClassName="modal_overlay">
            <div className="box_wrapper">
                <h4 className="fw-bold mb-3">{isCreate ? "Add Employee" : "Edit Employee"}</h4>

                <div className="modal_content_sm">
                    <div className="mb-3">
                        <label className="label">Name:</label>
                        <input className="form_control" type="text" value={name} onChange={(e) => setName(e.target.value)} />
                        {error && <p className="error-message d-block">{error}</p>}
                    </div>
                    <div className="mb-3">
                        <label className="label">Designation (optional):</label>
                        <input className="form_control" type="text" placeholder="e.g. Content Lister" value={designation} onChange={(e) => setDesignation(e.target.value)} />
                    </div>
                    <div className="mb-3">
                        <label className="label">Email (optional):</label>
                        <input className="form_control" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                </div>

                <div className="d-flex gap-2 justify-content-end mt-3">
                    <button type="button" className="btn btn-outline-secondary" onClick={handleCloseModal} disabled={isSubmit}>Cancel</button>
                    <Button onClick={handleSubmit} disabled={isSubmit} isSubmit={isSubmit} label="Saving ..." text={isCreate ? "Add" : "Update"} />
                </div>
            </div>
        </Modal>
    );
};

export default EmployeePopup;
